import { generateMetaTags, SITE_URL } from "~/lib/seo";

export function meta() {
	return generateMetaTags({
		title: "Obchodní podmínky – FirmIndex",
		description:
			"Obchodní podmínky služby FirmIndex upravující práva a povinnosti mezi poskytovatelem a uživateli.",
		canonical: `${SITE_URL}/podminky`,
	});
}

export default function Podminky() {
	return (
		<section className="px-6 py-16 lg:px-8 lg:py-24">
			<article className="prose prose-gray mx-auto max-w-3xl">
				<h1 className="text-4xl font-extrabold tracking-tight text-text">Obchodní podmínky</h1>
				<p className="mt-2 text-sm text-muted">Poslední aktualizace: 1. ledna 2026</p>

				<div className="mt-12 space-y-8 text-sm leading-relaxed text-muted">
					<section>
						<h2 className="text-xl font-bold text-text">1. Úvodní ustanovení</h2>
						<p>
							Tyto obchodní podmínky (dále jen „Podmínky") upravují práva a povinnosti mezi
							společností Recadev s.r.o., IČO: 07654090, se sídlem U Plesenky 3353/15, Martinov, 723
							00 Ostrava (dále jen „Poskytovatel") a uživateli služby FirmIndex (dále jen
							„Uživatel").
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">2. Definice pojmů</h2>
						<p>
							<strong>Služba</strong> — webová aplikace FirmIndex dostupná na adrese firmindex.cz,
							poskytující přístup k finančním a registračním datům českých firem.
						</p>
						<p>
							<strong>Uživatelský účet</strong> — účet vytvořený registrací Uživatele, umožňující
							přístup ke Službě a jejím funkcím.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">3. Registrace a uživatelský účet</h2>
						<p>
							Pro využívání placených funkcí Služby je nutná registrace. Uživatel je povinen uvést
							pravdivé a aktuální údaje. Poskytovatel si vyhrazuje právo zrušit účet Uživatele,
							který porušuje tyto Podmínky.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">4. Platební podmínky</h2>
						<p>
							Ceny za placené tarify jsou uvedeny na stránce Ceník. Platby se provádějí předem na
							měsíční nebo roční bázi. Při roční platbě má Uživatel nárok na slevu odpovídající
							dvěma měsícům.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">5. Práva a povinnosti Uživatele</h2>
						<p>
							Uživatel se zavazuje využívat Službu v souladu s platnými právními předpisy České
							republiky a těmito Podmínkami. Je zakázáno automatizované stahování dat bez
							předchozího písemného souhlasu Poskytovatele.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">6. Odpovědnost</h2>
						<p>
							Poskytovatel nenese odpovědnost za rozhodnutí učiněná na základě dat poskytovaných
							Službou. Data mají informativní charakter a nenahrazují odborné poradenství.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">7. Ukončení služby</h2>
						<p>
							Uživatel může svůj účet kdykoliv zrušit v nastavení profilu. Poskytovatel může Službu
							ukončit s 30denní výpovědní lhůtou. V případě ukončení placeného tarifu bude
							nevyčerpaná část předplatného vrácena.
						</p>
					</section>

					<section>
						<h2 className="text-xl font-bold text-text">8. Závěrečná ustanovení</h2>
						<p>
							Tyto Podmínky se řídí právním řádem České republiky. Pro řešení sporů jsou příslušné
							soudy České republiky. Poskytovatel si vyhrazuje právo tyto Podmínky jednostranně
							změnit s 30denním předstihem.
						</p>
					</section>
				</div>
			</article>
		</section>
	);
}
